import Pagination from "../../../../material/pagination/Pagination";
import PaginationConfig from "../../../../material/pagination/PaginationConfig";
import route from "../../../../enum/route";
import Operator from "../../../../material/pagination/Operator";
import Intervention from "../../../../entity/b2c/Intervention";
import PaginationColumn from "../../../../material/pagination/PaginationColumn";
import {useNavigate} from "react-router";
import Type from "../../../../material/pagination/Type";

export default function ({companyId}) {
    const navigate = useNavigate();

    return (
        <Pagination
            paginationConfig={
                new PaginationConfig()
                    .setId("intervention-list-b2c")
                    .setUri("/service-data-repository/entrepreneur/pagination/b2c/intervention")
                    .setOnRowClicked(row => navigate(route.ARTISAN_B2C_INTERVENTION.replace(":token", row.intervention_token)))
                    .setFieldAsId("intervention_id")
                    .addFixedFilter("company_id", Operator.EQUALS, companyId)
                    .addFixedFilter("intervention_status", Operator.EQUALS, Intervention.STATUS_IN_PROGRESS)
                    .setHideToolbar(true)
                    .setPerPage(5)
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Dossier")
                            .setField("order_id")
                            .setType(Type.NUMBER)
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Ville")
                            .setField("address_city")
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
            }
        />
    )
}